// extracted by mini-css-extract-plugin
export default {"primary":"#1b2050","secondary":"#027ffe","highlight":"#ff31a8","background":"#f2f3f5","white":"#fff"};